import { isValidCinemaPath } from "./constants";

/**
 * Normalize a raw lastVisitedLocation cookie value to a validated "/{lang}/{cinema}"
 * path, or null when the cookie is missing or stale (removed/renamed cinema slug, raw
 * CMS nodeUri with extra segments, ...).
 *
 * Shared by the h3 handler (server/middleware/02.cinemaRedirect.ts) and the route
 * middleware (middleware/02.redirectToValidCinema.global.ts) so both layers agree on
 * whether a cookie is usable. Redirecting onto an unvalidated cookie with the preserved
 * deep link appended would grow the URL on every middleware pass (redirect loop) instead
 * of converging on a valid cinema path.
 */
export const normalizeCinemaCookiePath = (
  raw: string | null | undefined,
): string | null => {
  if (!raw) return null;
  let value = raw;
  try {
    value = decodeURIComponent(raw); // cookie is usually URL-encoded ("%2Fcz%2Fopava")
  } catch (_) {
    // keep raw value
  }
  const seg = value.split("/").filter(Boolean);
  return isValidCinemaPath(seg[0], seg[1]) ? `/${seg[0]}/${seg[1]}` : null;
};
